export default {
  text: 'Ce restaurant est suspendu. Veuillez contacter votre interlocuteur ou nous écrire à <a>{{supportEmail}}</a> si vous souhaitez le rétablir',
};
